import React from 'react';
import { LandingTemplate } from '@/components/landing/landingTemplate';
import { GenerateLandingLinkService } from '@/services';
import { resolveFunnelUrlByMonetizationTest } from '@/helpers';
import { landingPassportPhotoMakerConfig } from '@/data/landingConfig/landingPassportPhotoMakerConfig';
import { MONETIZATION_TEST } from '@/constants';
import { AggregateSchema } from '../AggregateSchema';
import { schemaObject_PassportPhotoMaker } from './schemaObject';

interface Props {}
const PassportPhotoMaker: React.FC<Props> = () => {
	const funnelUrl = resolveFunnelUrlByMonetizationTest(
		{
			[MONETIZATION_TEST.NON_TIER_1]:
				GenerateLandingLinkService.funnelPassportPhotoMakerV2,
		},
		GenerateLandingLinkService.funnelPassportPhotoMaker,
	);

	return (
		<>
			<AggregateSchema schema={schemaObject_PassportPhotoMaker} />
			<LandingTemplate
				data={landingPassportPhotoMakerConfig}
				funnelLinkService={funnelUrl}
			/>
		</>
	);
};

export default PassportPhotoMaker;
